<template>
  <div class="manager_box">
    <div class="add_input_top">
      <el-button @click="handleClick_add" type="primary" size="small"
        >部门全体编辑</el-button
      >
    </div>

    <el-dialog
      title="部门全体编辑"
      :visible.sync="add_input"
      class="el_table_class"
    >
      <el-form label-width="200px">
        <el-form-item
          label="编辑所属部门"
          v-if="this.$cookies.get('auth_grade') == 100"
        >
          <el-select v-model="value" placeholder="请选择" class="label_input">
            <el-option
              v-for="item in options"
              :key="item.staff_id"
              :label="item.realname"
              :value="item.staff_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="A类别可存储时间（天）">
          <el-input-number
            class="label_input"
            v-model="A_category_input"
            :min="0"
            :max="31"
            label
          ></el-input-number>
        </el-form-item>
        <el-form-item label="B类别可存储时间（天）">
          <el-input-number
            class="label_input"
            v-model="B_category_input"
            :min="0"
            :max="31"
            label
          ></el-input-number>
        </el-form-item>
        <el-form-item label="C类别可存储时间（天）">
          <el-input-number
            class="label_input"
            v-model="C_category_input"
            :min="0"
            :max="31"
            label
          ></el-input-number>
        </el-form-item>
        <el-form-item label="D类别可存储时间（天）">
          <el-input-number
            class="label_input"
            v-model="D_category_input"
            :min="0"
            :max="31"
            label
          ></el-input-number>
        </el-form-item>
        <el-form-item label="私海可储存数量">
          <el-input-number
            class="label_input"
            v-model="private_sea_input"
            :min="0"
            :max="300"
            label
          ></el-input-number>
        </el-form-item>
        <el-form-item label="私海释放到公海拉取时间限制">
          <el-input-number
            class="label_input"
            v-model="readd_customer_input"
            @change="handleChange"
            :min="0"
            :max="31"
            label
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel_add">取 消</el-button>
        <el-button type="primary" @click="preservation_add">确 定</el-button>
      </span>
    </el-dialog>

    <div class="table_add">
      <el-table
        :data="tableData"
        style="width: 100%; min-height: 80vh"
        v-loading="tableData_loading"
        class="margin_table"
      >
        <el-table-column
          prop="realname"
          label="姓名"
          min-width="80"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="账号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="client_a"
          label="A类别可存储时间（天）"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.client_a }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="A_category_input"
                :min="0"
                :max="31"
                label
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="client_b"
          label="B类别可存储时间（天）"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id && !add_input">
              <span>{{ scope.row.client_b }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="B_category_input"
                :min="0"
                :max="31"
                label
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="client_c"
          label="C类别可存储时间（天）"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.client_c }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="C_category_input"
                :min="0"
                :max="31"
                label
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="client_d"
          label="D类别可存储时间（天）"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.client_d }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="D_category_input"
                :min="0"
                :max="31"
                label
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="client_count"
          label="私海可储存数量"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.client_count }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="private_sea_input"
                :min="0"
                :max="300"
                label
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="readd_customer"
          label="私海释放到公海拉取时间限制"
          min-width="180"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.readd_customer }}</span>
            </div>
            <div v-else>
              <el-input-number
                v-model="readd_customer_input"
                @change="handleChange"
                :min="0"
                :max="31"
                label
              ></el-input-number>
              <!-- <el-input v-model="readd_customer_input" placeholder="请输入内容"></el-input> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <el-button
                @click="handleClick(scope.row)"
                type="primary"
                size="small"
                >编辑</el-button
              >
              <!-- <el-button type="danger" size="small">删除</el-button> -->
            </div>
            <div v-else>
              <el-button
                @click="preservation(scope.row)"
                type="warning"
                size="small"
                >保存</el-button
              >
              <el-button type="info" @click="cancel" size="small"
                >取消</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_div">
        <el-pagination
          hide-on-single-page
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="15"
          layout="prev, pager, next, jumper"
          :total="user_count"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      tableData_loading: false, // 表格加载
      add_input: false,
      tableData: [], // 列表
      copy_tableData: [],
      tableData_id: "", // 列表选中的ID
      user_count: 0, // 总页数
      // 计数器
      A_category_input: "", // a
      B_category_input: "", // b
      C_category_input: "", // c
      D_category_input: "", // d
      private_sea_input: "", // 私海
      readd_customer_input: "", // 流放禁止拉取
      page: 0,

      options: [],
      value: "",
    };
  },
  created() {
    this.lufish_user_list(0);
    if (this.$cookies.get("auth_grade") == 100) {
      this.lufish_staff_list();
    }
  },
  methods: {
    lufish_user_list(page) {
      // 私海列表
      this.tableData_loading = true;
      require("POST", "/lufish_sale/v1/show_target_list/", { page }).then(
        (res) => {
          console.log("私海列表", res);
          if (!res.code) {
            this.user_count = res.data.target_count;
            this.tableData = res.data.target_data;
          } else {
            this.$message.error("列表获取失败");
          }
          this.tableData_loading = false;
        }
      );
    },
    lufish_staff_list() {
      require("post", "/lufish_user/v1/lufish_staff_list/", {}).then((res) => {
        console.log("内容", res);
        if (!res.code) {
          let add = [];
          res.data.forEach((item, index) => {
            if (index != 0) {
              add.push(item);
            }
          });
          this.options = add;
        }
      });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val - 1;
      this.lufish_user_list(val - 1);
    },
    handleClick(e) {
      console.log(e);
      this.tableData_id = e.staff_id;
      this.A_category_input = e.client_a;
      this.B_category_input = e.client_b;
      this.C_category_input = e.client_c;
      this.D_category_input = e.client_d;
      this.private_sea_input = e.client_count;
      this.readd_customer_input = e.readd_customer;
    },
    preservation(e) {
      // 保存
      console.log(
        "内容",
        e,
        !this.A_category_input,
        !this.B_category_input,
        this.C_category_input,
        this.D_category_input
      );
      if (!this.A_category_input) {
        this.$message({ message: "A类储存时间有误", type: "warning" });
        return false;
      } else if (!this.B_category_input) {
        this.$message({ message: "B类储存时间有误", type: "warning" });
        return false;
      } else if (!this.C_category_input) {
        this.$message({ message: "C类储存时间有误", type: "warning" });
        return false;
      } else if (!this.D_category_input) {
        this.$message({ message: "D类储存时间有误", type: "warning" });
        return false;
      } else if (!this.private_sea_input) {
        this.$message({ message: "储存量有误", type: "warning" });
        return false;
      }
      this.tableData_loading = true;
      require("POST", "/lufish_user/v1/lufish_client/", {
        staff_id: e.staff_id,
        client_a: this.A_category_input, //  私海中A类客户保护时间
        client_b: this.B_category_input, //  私海中B类客户保护时间
        client_c: this.C_category_input, //  私海中C类客户保护时间
        client_d: this.D_category_input, //  私海中D类客户保护时间
        client_count: this.private_sea_input,
        readd_customer: this.readd_customer_input,
      }).then((res) => {
        if (!res.code) {
          e.client_a = this.A_category_input;
          e.client_b = this.B_category_input;
          e.client_c = this.C_category_input;
          e.client_d = this.D_category_input;
          e.client_count = this.private_sea_input;
          e.readd_customer = this.readd_customer_input;
          this.tableData_id = "";
          this.$message({ message: "更新成功", type: "success" });
        } else {
          this.$message.error("更新失败");
        }
        this.tableData_loading = false;
      });
    },
    cancel() {
      this.tableData_id = "";
      console.log("取消保存");
    },
    handleChange(e) {
      // console.log('当前数', e)
    },

    handleClick_add() {
      // 编辑
      this.value = "";
      this.A_category_input = 0;
      this.B_category_input = 0;
      this.C_category_input = 0;
      this.D_category_input = 0;
      this.private_sea_input = 0;
      this.readd_customer_input = 0;
      this.add_input = true;
    },
    preservation_add() {
      // 保存
      this.page = 0;
      let Obj = {};
      if (this.value == "" && this.$cookies.get("auth_grade") == 100) {
        this.$message({ message: "请选择部门", type: "warning" });
        return false;
      } else {
        Obj.product_name = this.value;
      }
      if (!this.A_category_input) {
        this.$message({ message: "A类储存时间有误", type: "warning" });
        return false;
      } else if (!this.B_category_input) {
        this.$message({ message: "B类储存时间有误", type: "warning" });
        return false;
      } else if (!this.C_category_input) {
        this.$message({ message: "C类储存时间有误", type: "warning" });
        return false;
      } else if (!this.D_category_input) {
        this.$message({ message: "D类储存时间有误", type: "warning" });
        return false;
      } else if (!this.private_sea_input) {
        this.$message({ message: "储存量有误", type: "warning" });
        return false;
      } else {
        Obj.client_a = this.A_category_input; // a
        Obj.client_b = this.B_category_input; // b
        Obj.client_c = this.C_category_input; // c
        Obj.client_d = this.D_category_input; // d
        Obj.client_count = this.private_sea_input; // 私海
        Obj.readd_customer = this.readd_customer_input; // 流放禁止拉取
      }
      this.tableData_loading = true;
      this.add_input = false;
      require("POST", "/lufish_user/v1/lufish_client_all/", Obj).then((res) => {
        if (!res.code) {
          this.lufish_user_list(this.page);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel_add() {
      // 取消
      this.add_input = false;
    },
  },
};
</script>
<style scoped>
.table_add {
  /* border:1px red solid; */
  padding: 20px;
  background: white;
}
.pagination_div {
  margin: 20px auto;
  text-align: center;
}
.add_input_top {
  display: flex;
  justify-content: flex-end;
  padding: 6px 20px;
}
.label_input {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/staff_setup.vue